export default "__VITE_ASSET__eaa14253__"